module.exports = __webpack_public_path__ + "img/GreekTechGastrophesS_ua.63884a85.webp";